import { useEffect, useRef, useState } from 'react';
import Modal from '../../components/Modal';
import Input from '../../components/Input';
import Button from '../../components/Button';
import ErrorMessages from '../../components/ErrorMessages.js';
import parkingAPI from '../../api/parking';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';
import useLockBodyScroll from '../../customHooks/useLockBodyScroll';

// Move parking cards for a blocked-date game between the blocked lot and its
// fallback lot, in batches (the alternative may not fit them all at once).
const SwitchBatchModal = ({ sperr, blockedFieldName, fallbackFieldName, onClose, onDone }) => {
    const modalRef = useRef(null);
    useLockBodyScroll();
    const [status, setStatus] = useState(null);
    const [count, setCount] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const loadStatus = async () => {
        try {
            const res = await parkingAPI.getSwitchStatus(sperr.sperrId);
            setStatus(res.data);
        } catch (e) {
            setStatus(null);
        }
    };

    useEffect(() => {
        loadStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const move = async (direction) => {
        const n = parseInt(count, 10);
        if (!n || n < 1) {
            setError('Bitte eine Anzahl grösser als 0 eingeben.');
            return;
        }
        setBusy(true);
        setError(null);
        try {
            const res = await parkingAPI.switchBatch(sperr.sperrId, { count: n, direction });
            setStatus(res.data);
            setCount('');
            onDone && onDone();
        } catch (err) {
            setError(requsetErrorMessage(err && err.message ? err.message : err));
        }
        setBusy(false);
    };

    return (
        <Modal
            title="Parkkarten umbuchen"
            ref={modalRef}
            onClose={onClose}
            maxWidth="480px"
            disabled={busy}
        >
            <p style={{ color: '#333', marginBottom: '10px' }}>
                Gesperrt: <b>{blockedFieldName}</b> ({sperr.date})<br />
                Ausweichplatz: <b>{fallbackFieldName || '—'}</b>
            </p>

            {status && (
                <div style={{ color: '#333', margin: '15px 0', lineHeight: 1.7 }}>
                    Total Karten für dieses Spiel: <b>{status.total}</b>
                    <br />
                    Auf gesperrtem Platz: <b>{status.at_blocked}</b>
                    <br />
                    Auf Ausweichplatz: <b>{status.at_fallback}</b>
                </div>
            )}

            <Input
                label="Anzahl (Batch)"
                type="number"
                value={count}
                onChange={(e) => setCount(e.target.value)}
            />

            <div style={{ marginTop: '15px' }}>
                <ErrorMessages messages={error || ''} />
            </div>

            <div className="Modal-Controls" style={{ marginTop: '20px' }}>
                <Button
                    label="Umbuchen →"
                    loading={busy}
                    disabled={busy || !(status && status.at_blocked > 0)}
                    onClick={() => move('to_fallback')}
                    style={{ width: '150px' }}
                />
                <Button
                    label="← Zurückbuchen"
                    theme="gray"
                    disabled={busy || !(status && status.at_fallback > 0)}
                    onClick={() => move('to_field')}
                    style={{ width: '150px', marginLeft: '15px' }}
                />
            </div>

            <div className="Modal-Controls" style={{ marginTop: '15px' }}>
                <Button label="Schliessen" theme="light" disabled={busy} onClick={onClose} />
            </div>
        </Modal>
    );
};

export default SwitchBatchModal;
